import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Check, ArrowLeft } from "lucide-react";
import api from "@/lib/api";
import { openWhatsApp } from "@/lib/whatsapp";
import { PrimaryLink } from "@/components/public/ui";
import useSeo from "@/lib/useSeo";

export default function ServiceDetail() {
  const { slug } = useParams();
  const [s, setS] = useState(null);
  useEffect(() => { api.get(`/services/${slug}`).then(({ data }) => setS(data)).catch(() => setS(false)); }, [slug]);
  useSeo({ title: s?.seo_title || s?.name, description: s?.seo_description || s?.short_desc, image: s?.image });
  if (s === null) return <div className="max-w-7xl mx-auto px-6 py-32 text-center text-slate-400">Chargement…</div>;
  if (s === false) return <div className="max-w-7xl mx-auto px-6 py-32 text-center text-slate-500">Service introuvable. <Link to="/services" className="text-[#0F2A6B] underline">Retour</Link></div>;
  return (
    <div>
      <section className="bg-gradient-to-br from-[#0F2A6B] to-[#0A1F52] relative grain">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-16 relative">
          <Link to="/services" className="inline-flex items-center gap-2 text-slate-300 hover:text-white text-sm mb-6"><ArrowLeft className="w-4 h-4" /> Tous les services</Link>
          <h1 className="text-4xl sm:text-5xl font-bold text-white font-head">{s.name}</h1>
          <p className="mt-4 text-lg text-slate-300 max-w-2xl">{s.short_desc}</p>
        </div>
      </section>
      <section className="max-w-7xl mx-auto px-4 sm:px-6 py-16 grid lg:grid-cols-3 gap-10">
        <div className="lg:col-span-2 space-y-8">
          <p className="text-slate-600 leading-relaxed whitespace-pre-line">{s.description}</p>
          {Array.isArray(s.prestations) && s.prestations.length > 0 && (
            <div><h2 className="text-2xl font-bold text-slate-900 font-head mb-4">Nos prestations</h2>
              <div className="grid sm:grid-cols-2 gap-3">{s.prestations.map((p) => (<div key={p} className="flex items-center gap-2 text-slate-700 p-3 rounded-xl bg-white border border-slate-200"><Check className="w-5 h-5 text-[#4CB944] shrink-0" />{p}</div>))}</div></div>
          )}
        </div>
        <aside>
          <div className="p-6 rounded-2xl bg-white border border-slate-200 shadow-sm sticky top-24">
            <h3 className="font-semibold text-slate-900 font-head">Un projet en tête ?</h3>
            <p className="text-sm text-slate-600 mt-2">Parlons de votre besoin dès aujourd'hui.</p>
            <PrimaryLink to="/devis" testid="service-devis-button" className="w-full mt-4">Demander un devis</PrimaryLink>
            <button onClick={() => openWhatsApp({ page: "service", service: s.name })} className="w-full mt-3 inline-flex items-center justify-center px-6 py-3 rounded-full border border-[#0F2A6B]/20 text-[#0F2A6B] font-semibold hover:bg-[#0F2A6B]/5">Discuter sur WhatsApp</button>
          </div>
        </aside>
      </section>
    </div>
  );
}
